import React, { useState } from 'react';
import { WeChatQRCode } from 'Components/widgets/payment-info/payment-process/WechatQRCode';
import { WeChatTutorial } from 'Components/widgets/payment-info/payment-process/WeChatTutorial';
type Props = {
  currency: string;
  qrCodeUrl: string;
  amountToPay: number;
  orderId: string;
  customerId: string;
  timeoutCallback: () => void;
};
export const WeChatPayment = ({
  currency,
  qrCodeUrl,
  amountToPay,
  orderId,
  customerId,
  timeoutCallback,
}: Props) => {
  const [hasTransactionExpired, setHasTransactionExpired] = useState(false);

  if (hasTransactionExpired) {
    return <WeChatTutorial hasTransactionExpired={hasTransactionExpired} />;
  }

  return (
    <WeChatQRCode
      timeoutCallback={() => {
        timeoutCallback();
        setHasTransactionExpired(true);
      }}
      currency={currency}
      qrCodeUrl={qrCodeUrl}
      orderId={orderId}
      customerId={customerId}
      amountToPay={amountToPay}
    />
  );
};
